(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deeve-col-carat-chips"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.querySelector('[data-carat-chips]');
  if (!wrap) return;
  var chips = Array.prototype.slice.call(wrap.querySelectorAll('.deeve-caratchips__chip'));
  function cardsOf() { return Array.prototype.slice.call(document.querySelectorAll('#ResultsList .deeve-card, .product-grid .deeve-card')); }
  function rowOf(card) { return card.closest('li') || card.closest('product-card') || card; }
  function apply(min, max) {
    cardsOf().forEach(function (card) {
      var c = parseFloat(card.getAttribute('data-carat'));
      var show = isNaN(c) || (c >= min - 0.001 && c <= max + 0.001);
      var row = rowOf(card);
      row.hidden = !show;
      row.style.display = show ? '' : 'none';
    });
    chips.forEach(function (ch) {
      var on = parseFloat(ch.getAttribute('data-carat-min')) === min && parseFloat(ch.getAttribute('data-carat-max')) === max;
      ch.classList.toggle('is-active', on);
      ch.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function current() {
    var m = /carat=([\d.]+)-([\d.]+)/.exec(location.hash || '');
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : [0, 999];
  }
  chips.forEach(function (ch) {
    ch.addEventListener('click', function (e) {
      e.preventDefault();
      var min = parseFloat(ch.getAttribute('data-carat-min')), max = parseFloat(ch.getAttribute('data-carat-max'));
      apply(min, max);
      var h = (min === 0 && max === 999) ? '' : '#carat=' + min + '-' + max;
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + h); else location.hash = h;
    });
  });
  var cur = current();
  if (!(cur[0] === 0 && cur[1] === 999)) apply(cur[0], cur[1]);
  var list = document.getElementById('ResultsList');
  if (list && window.MutationObserver) {
    new MutationObserver(function () { var c = current(); if (!(c[0] === 0 && c[1] === 999)) apply(c[0], c[1]); }).observe(list, { childList: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deeve-col-style-chips"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.querySelector('[data-style-chips]');
  if (!wrap) return;
  var param = wrap.getAttribute('data-param');
  var chips = Array.prototype.slice.call(wrap.querySelectorAll('.deeve-stylechips__chip'));
  function sync() {
    var p = new URLSearchParams(location.search);
    var on = p.getAll(param);
    p.delete(param); p.delete('page');
    var rest = p.toString();
    var base = location.pathname + (rest ? '?' + rest : '');
    var join = rest ? '&' : '?';
    chips.forEach(function (ch) {
      var s = ch.getAttribute('data-style');
      var lit = s ? (on.length === 1 && on[0] === s) : on.length === 0;
      ch.classList.toggle('is-active', lit);
      ch.setAttribute('aria-pressed', lit ? 'true' : 'false');
      ch.setAttribute('href', (!s || lit) ? base : base + join + encodeURIComponent(param) + '=' + encodeURIComponent(s));
    });
  }
  // the filter drawer swaps the grid and rewrites the URL without a page load (measured on
  // CHIPS-1: it replaces a node INSIDE #ResultsList), so follow the URL, not one element
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    if (typeof orig !== 'function') return;
    history[m] = function () { var r = orig.apply(this, arguments); setTimeout(sync, 0); return r; };
  });
  window.addEventListener('popstate', sync);
  var list = document.getElementById('ResultsList');
  if (list && window.MutationObserver) new MutationObserver(sync).observe(list, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deeve-home-ask"] && !Shopify.designMode) return;
  try {
    
// Hands a typed question to the ONE concierge widget in layout/theme.liquid.
// Runs on click and Enter ONLY. Never auto-opens the chat — see the section comment.
document.querySelectorAll('[data-deeve-bijan]').forEach((panel) => {
  const input = panel.querySelector('[data-deeve-bijan-input]');
  const send = panel.querySelector('[data-deeve-bijan-send]');
  if (!send) return;

  const handOver = (question) => {
    const bubble = document.querySelector('.shop-ai-chat-bubble');
    if (!bubble) return false; // concierge disabled: let the mailto href run
    bubble.click();
    if (!question) return true;
    let tries = 0;
    const deliver = () => {
      const field = document.querySelector('#deeve-concierge-input');
      const submit = document.querySelector('.shop-ai-chat-send');
      if (field && submit) {
        field.value = question;
        field.dispatchEvent(new Event('input', { bubbles: true }));
        submit.click();
        if (input) input.value = '';
      } else if (tries++ < 20) {
        setTimeout(deliver, 100);
      }
    };
    setTimeout(deliver, 300);
    return true;
  };

  send.addEventListener('click', (event) => {
    if (handOver(input ? input.value.trim() : '')) event.preventDefault();
  });

  if (input) {
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      if (!handOver(input.value.trim())) window.location.href = send.href;
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deeve-home-founder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-deeve-ask]').forEach((box) => {
  const input = box.querySelector('[data-deeve-ask-input]');
  const send = box.querySelector('[data-deeve-ask-send]');
  if (!input || !send) return;
  const to = box.dataset.mailto;
  const subject = box.dataset.subject || '';
  const compose = () => {
    const q = input.value.trim();
    send.href = 'mailto:' + to + '?subject=' + encodeURIComponent(subject) + (q ? '&body=' + encodeURIComponent(q) : '');
  };
  input.addEventListener('input', compose);
  input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { compose(); send.click(); } });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
